import Login from "@/components/Login";
import Dashboard from "@/components/Dashboard";
import Settings from "@/components/Settings";

export const routes = [
  {
    path: "*",
    redirect: "/dashboard"
  },
  {
    path: "/login",
    name: "Login",
    component: Login
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/settings",
    name: "Settings",
    component: Settings,
    meta: {
      requiresAuth: true
    }
  }
];
